export const TASK_ENDPOINT = `https://${process.env.NEXT_PUBLIC_CRM_TASK_DOMAIN_NAME}`;
